export default {"src":"/_next/static/media/Widget.f5633039.svg","height":280,"width":346,"blurWidth":0,"blurHeight":0};